import request from "@/utils/request";
import { watch } from "vue";

const { ElMessage } = require("element-plus");

export default {
  name: "StuInfo",
  data() {
    // 手机号验证
    const checkPhone = (rule, value, callback) => {
      const phoneReg = /^1[3|4|5|6|7|8][0-9]{9}$/;
      if (!value) {
        return callback(new Error("电话号码不能为空"));
      }
      setTimeout(() => {
        if (!Number.isInteger(+value)) {
          callback(new Error("请输入数字值"));
        } else {
          if (phoneReg.test(value)) {
            callback();
          } else {
            callback(new Error("电话号码格式不正确"));
          }
        }
      }, 100);
    };
    const checkPass = (rule, value, callback) => {
      if (!this.editJudge) {
        if (value == "") {
          callback(new Error("请再次输入密码"));
        } else if (value !== this.form.password) {
          callback(new Error("两次输入密码不一致!"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      showpassword: true,
      judgeAddOrEdit: true,
      loading: true,
      editJudge: true,
      disabled: false,
      judge: false,
      dialogVisible: false,
      search: "",
      isCheckIn:0,
      searchPhone: "",
      searchUnit: "",
      searchClass: "",
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      classOptions: [], // 班级下拉选项
      importStudentFile: null,
      importDialogVisible: false,
      uploadHeaders: {},
      form: {
        username: "",
        name: "",
        age: "",
        gender: "",
        phoneNum: "",
        email: "",
        unit: "",
        classNum: "",
      },
      rules: {
        username: [
          { required: () => this.judgeAddOrEdit, message: "请输入学号", trigger: "blur" },
        ],
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          {
            pattern: /^(?:[\u4E00-\u9FA5·]{2,10})$/,
            message: "必须由 2 到 10 个汉字组成",
            trigger: "blur",
          },
        ],
        // age: [
        //   { required: true, message: "请输入年龄", trigger: "blur" },
        //   { type: "number", message: "年龄必须为数字值", trigger: "blur" },
        //   {
        //     pattern: /^(1|[1-9]\d?|100)$/,
        //     message: "范围：1-100",
        //     trigger: "blur",
        //   },
        // ],
        gender: [{ required: true, message: "请选择性别", trigger: "change" }],
        // phoneNum: [{ required: true, validator: checkPhone, trigger: "blur" }],
        email: [
          { type: "email", message: "请输入正确的邮箱地址", trigger: "blur" },
        ],
        password: [
          // 密码只在添加时必填，编辑时可选
          // 编辑模式下不验证密码，如果用户不输入密码则保持原密码
        ],
        checkPass: [],
      },
      editDisplay: {
        display: "block",
      },
      display: {
        display: "none",
      },
      filterValue:[]
    };
  },
  watch: {
    '$route'(to, from) {
       // 获取query参数
    if(this.$route.query.isHas==='1'){
        this.isCheckIn=1;
    }else{
      this.isCheckIn=0;
    }
    this.load();
    this.loading = true;
    setTimeout(() => {
      //设置延迟执行
      this.loading = false;
    }, 1000);
    }
  },
  created() {
     // 获取query参数
    if(this.$route.query.isHas==='1'){
        this.isCheckIn=1;
    }else{
      this.isCheckIn=0;
    }
    this.load();
    this.loadClassList(); // 加载班级列表
    this.loading = true;
    setTimeout(() => {
      //设置延迟执行
      this.loading = false;
    }, 1000);
  },
  methods: {
    // 加载班级列表
    loadClassList() {
      request.get("/classInfo/list").then(res => {
        if (res.code === '0') {
          this.classOptions = res.data || [];
        }
      }).catch(err => {
        console.error('获取班级列表失败', err);
      });
    },
    checkInFilterTag(value, row) {
      if (value == "has") {
        return row.dormRoom != null;
      }
      return true;
    },
    async load() {
      request
        .get("/stu/find", {
          params: {
            pageNum: this.currentPage,
            pageSize: this.pageSize,
            search: this.search,
            phoneNum: this.searchPhone,
            unit: this.searchUnit,
            classNum: this.searchClass,
            isCheckIn:this.isCheckIn||0
          },
        })
        .then((res) => {
          this.tableData = res.data.records;
          this.total = res.data.total;
          this.loading = false;
        });
    },
    reset() {
      this.search = "";
      this.searchPhone = "";
      this.searchUnit = "";
      this.searchClass = "";
      this.currentPage = 1;
      request
        .get("/stu/find", {
          params: {
            pageNum: 1,
            pageSize: this.pageSize,
            search: this.search,
          },
        })
        .then((res) => {
          console.log(res);
          this.tableData = res.data.records;
          this.total = res.data.total;
          this.loading = false;
        });
    },
    filterTag(value, row) {
      return row.gender === value;
    },
    add() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form.resetFields();
        this.judgeAddOrEdit = false;
        this.editDisplay = { display: "none" };
        this.disabled = false;
        this.form = {};
        this.judge = false;
      });
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.judge === false) {
            //新增 - 不传递学号和密码（由后台生成）
            const formData = { ...this.form };
            delete formData.username;
            delete formData.password;
            delete formData.checkPass;
            request.post("/stu/add", formData).then((res) => {
              console.log(res);
              if (res.code === "0") {
                ElMessage({
                  message: "新增成功",
                  type: "success",
                });
                this.search = "";
                this.loading = true;
                this.load();
                this.dialogVisible = false;
              } else {
                ElMessage({
                  message: res.msg,
                  type: "error",
                });
              }
            });
          } else {
            //修改
            request.put("/stu/update", this.form).then((res) => {
              console.log(res);
              if (res.code === "0") {
                ElMessage({
                  message: "修改成功",
                  type: "success",
                });
                this.search = "";
                this.load();
                this.dialogVisible = false;
              } else {
                ElMessage({
                  message: res.msg,
                  type: "error",
                });
              }
            });
          }
        }
      });
    },
    cancel() {
      this.$refs.form.resetFields();
      this.display = { display: "none" };
      this.editJudge = true;
      this.disabled = true;
      this.showpassword = true;
      this.dialogVisible = false;
    },
    EditPass() {
      if (this.editJudge) {
        this.showpassword = false;
        this.display = { display: "flex" };
        this.disabled = false;
        this.editJudge = false;
      } else {
        this.showpassword = true;
        this.display = { display: "none" };
        this.editJudge = true;
        this.disabled = true;
      }
    },
    handleEdit(row) {
      //修改
      //判断操作类型
      this.judge = true;
      // 生拷贝
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form.resetFields();
        this.form = JSON.parse(JSON.stringify(row));
        this.judgeAddOrEdit = true;
        this.editDisplay = { display: "block" };
        this.disabled = true;
      });
    },
    async handleDelete(username) {
      //删除
      console.log(username);
      request.delete("/stu/delete/" + username).then((res) => {
        if (res.code === "0") {
          ElMessage({
            message: "删除成功",
            type: "success",
          });
          this.search = "";
          this.load();
        } else {
          ElMessage({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    handleSizeChange(pageSize) {
      //改变每页个数
      this.pageSize = pageSize;
      this.currentPage = 1;
      this.load();
    },
    handleCurrentChange(pageNum) {
      this.currentPage = pageNum;
      this.load();
    },
    handleSearch() {
      this.currentPage = 1;
      this.load();
    },
    // 学员导入方法
    handleImportStudent() {
      this.importDialogVisible = true;
      this.importStudentFile = null;
    },
    handleStudentFileChange(file) {
      this.importStudentFile = file.raw;
    },
    cancelImportStudent() {
      this.importStudentFile = null;
      this.importDialogVisible = false;
      if (this.$refs.uploadStudentRef) {
        this.$refs.uploadStudentRef.clearFiles();
      }
    },
    confirmImportStudent() {
      if (!this.importStudentFile) {
        ElMessage({ message: "请选择文件", type: "warning" });
        return;
      }
      const formData = new FormData();
      formData.append("file", this.importStudentFile);
      request.post("/execl/importStudents", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      }).then((res) => {
        if (res.code === "0") {
          const success = res.successCount || 0;
          const fail = res.failCount || 0;
          const skip = res.skipCount || 0;
          const total = res.totalCount || 0;
          let msg = `导入完成，共${total}条：成功${success}条`;
          if (fail > 0) msg += `，失败${fail}条`;
          if (skip > 0) msg += `，跳过(重复)${skip}条`;
          ElMessage({ message: msg, type: fail > 0 ? "warning" : "success" });
          this.cancelImportStudent();
          this.load();
        } else {
          ElMessage({ message: res.msg || '导入失败', type: "error" });
        }
      }).catch((err) => {
        ElMessage({ message: '导入请求失败: ' + (err.message || '未知错误'), type: "error" });
      });
    },
    downloadStudentTemplate() {
      fetch('/execl/studentTemplate')
        .then(response => {
          if (!response.ok) throw new Error('下载模板失败');
          return response.blob();
        })
        .then(blob => {
          const blobUrl = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = blobUrl;
          link.download = '学员信息导入模板.xlsx';
          link.click();
          window.URL.revokeObjectURL(blobUrl);
        })
        .catch(err => {
          ElMessage({ message: '下载模板失败: ' + err.message, type: 'error' });
        });
    },
    handleExport() {
      const search = this.search || '';
      const phoneNum = this.phoneNum || '';
      const unit = this.unit || '';
      const classNum = this.searchClass || '';
      let url = `/stu/export?search=${encodeURIComponent(search)}&phoneNum=${encodeURIComponent(phoneNum)}&unit=${encodeURIComponent(unit)}`;
      if (classNum) url += `&classNum=${encodeURIComponent(classNum)}`;
      ElMessage({ message: '正在导出，请稍候...', type: 'info' });
      fetch(url)
        .then(response => {
          if (!response.ok) throw new Error('导出失败');
          return response.blob();
        })
        .then(blob => {
          const blobUrl = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = blobUrl;
          const now = new Date();
          const dateStr = now.getFullYear() +
            String(now.getMonth() + 1).padStart(2, '0') +
            String(now.getDate()).padStart(2, '0') +
            String(now.getHours()).padStart(2, '0') +
            String(now.getMinutes()).padStart(2, '0') +
            String(now.getSeconds()).padStart(2, '0');
          link.download = `学员信息${dateStr}.xlsx`;
          link.click();
          window.URL.revokeObjectURL(blobUrl);
          ElMessage({ message: '导出成功', type: 'success' });
        })
        .catch(err => {
          ElMessage({ message: '导出失败: ' + err.message, type: 'error' });
        });
    },
    submitImport() {
      this.$refs.importUploadRef.submit();
    },
    handleImportSuccess(res) {
      this.importDialogVisible = false;
      if (res.code === 0 || res.code === 200 || res.code === '0') {
        const msg = res.msg || `导入成功${res.successCount || 0}条`;
        ElMessage({ message: msg, type: 'success' });
        this.load();
      } else {
        ElMessage({ message: res.msg || '导入失败', type: 'error' });
      }
    },
    handleImportError() {
      ElMessage({ message: '导入请求失败', type: 'error' });
    },
    downloadStudentTemplate() {
      const link = document.createElement('a');
      link.href = '/execl/studentTemplate';
      link.download = '学员信息导入模板.xlsx';
      link.click();
    },
  },
};
